const SET_JOINT_LIFE_ADDENDUM_DETAILS = "SET_JOINT_LIFE_ADDENDUM_DETAILS";
const SAVE_JOINT_LIFE_ADDENDUM_DETAILS = "SAVE_JOINT_LIFE_ADDENDUM_DETAILS";
const POPULATE_JOINT_PINOCODE_DATA = "POPULATE_JOINT_PINOCODE_DATA";
const SET_JOINT_SUB_OCCUPATION_DATA = "SET_JOINT_SUB_OCCUPATION_DATA";
const SET_JOINT_MASTER_DATA = "SET_JOINT_MASTER_DATA";
const SET_JOINT_COUNTRY_NAME = "SET_JOINT_COUNTRY_NAME";
const SET_JOINT_REVIEW_DATA = "SET_JOINT_REVIEW_DATA";
const SET_JOINT_COUNTRY_DATA = "SET_JOINT_COUNTRY_DATA";
const SET_JOINT_LIFE_COVID_AND_NRI_DETAILS = "SET_JOINT_LIFE_COVID_AND_NRI_DETAILS";
const SET_JOINT_LIFE_FREEZE_DATA = "SET_JOINT_LIFE_FREEZE_DATA";
const SAVE_JOINT_MEMBER_ID = "SAVE_JOINT_MEMBER_ID";
const SET_JOINT_LIFE_ADDENDUM_DETAILS_V2 = "SET_JOINT_LIFE_ADDENDUM_DETAILS_V2";

export {
  SET_JOINT_LIFE_ADDENDUM_DETAILS,
  SAVE_JOINT_LIFE_ADDENDUM_DETAILS,
  POPULATE_JOINT_PINOCODE_DATA,
  SET_JOINT_SUB_OCCUPATION_DATA,
  SET_JOINT_MASTER_DATA,
  SET_JOINT_COUNTRY_NAME,
  SET_JOINT_REVIEW_DATA,
  SET_JOINT_COUNTRY_DATA,
  SET_JOINT_LIFE_COVID_AND_NRI_DETAILS,
  SET_JOINT_LIFE_FREEZE_DATA,
  SAVE_JOINT_MEMBER_ID,
  SET_JOINT_LIFE_ADDENDUM_DETAILS_V2
};
